import React from 'react';
import CTABuilder from './ctaFactory';

const CTA = ({
  component,
  onClickCB,
  data,
  style,
  closeModal,
  isActive = true,
  openModal,
  callback,
  options,
  ...restProps
}) => {
  const ctaBuilder = new CTABuilder();
  const {Renderer, clickHandler} = ctaBuilder.create({component, action: data?.action});

  return (
    <Renderer
      {...restProps}
      {...(data || {})}
      onClick={() => {
        clickHandler.map((handle, index) => {
          handle?.({
            data,
            onClickCB,
            closeModal,
            openModal,
            index,
            callback,
          });
        });
      }}
      label={data?.label ? data.label : isActive ? data?.activeLabel : data?.inactiveLabel}
      value={data?.label}
      leftIconClass={data?.leftIconClass}
      style={style}
      id={data?.id}
      checked={data?.checked}
      disabled={!isActive}
    />
  );
};

export default CTA;
